import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'
import { employeeTypes } from 'modules/contracts/lib/frenchContractData'

interface Props {
  employeeType?: string
}

const EmployeeType = ({ employeeType }: Props) => {
  const description = employeeType ? employeeTypes()[employeeType] : undefined

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.employee_type')}
      description={description}
    />
  )
}

export default EmployeeType
